module.exports = __webpack_public_path__ + "static/media/format_align_center-24px.d23358d3.svg";